<template>
  <div class="app-sidebar">
    <AppSidebarItemBrand />
    <AppSidebarItemUser />
    <AppSidebarItemNode @click="onClickSidebarItem" />
    <AppSidebarItemPack @click="onClickSidebarItem" />
    <AppSidebarItemSeries @click="onClickSidebarItem" />
    <AppSidebarItemTrail @click="onClickSidebarItem" />
    <AppSidebarItemTheme />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import AppSidebarItemBrand from './components/app-sidebar-item-brand';
import AppSidebarItemSeries from './components/app-sidebar-item-series';
import AppSidebarItemTheme from './components/app-sidebar-item-theme';
import AppSidebarItemUser from './components/app-sidebar-item-user';
import AppSidebarItemTrail from './components/app-sidebar-item-trail';
import AppSidebarItemNode from './components/app-sidebar-item-node';
import AppSidebarItemPack from './components/app-sidebar-item-pack';

export default defineComponent({
  name: 'AppSidebar',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      isSidebarActive: 'layout/isSidebarActive',
    }),
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setIsSidebarActive: 'layout/setIsSidebarActive',
    }),

    onClickSidebarItem() {
      if (this.isSidebarActive) {
        this.setIsSidebarActive(false);
      }
    },
  },

  /**
   * 使用组件
   */
  components: {
    AppSidebarItemBrand,
    AppSidebarItemSeries,
    AppSidebarItemTheme,
    AppSidebarItemUser,
    AppSidebarItemTrail,
    AppSidebarItemNode,
    AppSidebarItemPack,
  },
});
</script>

<style scoped>
@import './styles/app-sidebar.css';
</style>
